export default __webpack_public_path__ + "static/media/insulation_box.48770173.JPG";